import { Flavor } from "./flavor";
import { color2 } from "src/styles";

class AldiFlavor extends Flavor {
  getMainColor() {
    return color2.BLUE_AIFI;
  }

  getDashLineColor() {
    return color2.LIGHT_BLUE2;
  }
}

const Singleton = new AldiFlavor();
export default Singleton;
